import { createAsyncThunk } from '@reduxjs/toolkit';

import { UserApiPaths } from '../../dataProvider/APIPaths';
import APIDataProvider from '../../dataProvider/APIDataProvider';
import { IBookmark } from '.';

const BookmarkApiDataProvider = new APIDataProvider<IBookmark>();

export const createBookmark = createAsyncThunk(
  'user/bookmark/create',
  async (data: IBookmark) => {
    const response = await BookmarkApiDataProvider.create(
      `${UserApiPaths.bookmark}`,
      data
    );
    return response.data;
  }
);

export const getBookmark = createAsyncThunk(
  'user/bookmark/get',
  async (data: { tutorId: string; studentId: string; subject: string }) => {
    const path = `${UserApiPaths.bookmark}?tutorId=${data.tutorId}&studentId=${data.studentId}&subject=${data.subject}`;
    const response = await BookmarkApiDataProvider.getById(path);
    return response.data;
  }
);
